import React from 'react'; 
import { useEffect,useState } from 'react'; 
import styled from "styled-components";
import { useLanguage } from "@/app/utils/LanguageContext";
import { textSize, text_size } from "@/app/utils/MixinSize";

const Container = styled.div`
&.race-gear-legend{
    color: #333;
    display: none;
    text-align: left;
    width: 600px;
    right: 10px;
    // bottom: 60px; 
    background-color: #f4f4f4;
    padding: 0;
    height: auto;
    border-radius: 10px;
    box-shadow: 0px 3px 8px #333;
    z-index: 999;
}
&.pa {position: absolute;}

 div {
    display: block;
    text-align: left;
    height: auto;
    padding: 0;
    line-height: 14px
}

 h5 {
    ${text_size(15)}
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    font-weight: bold;
    background-color: #122c68;
    margin: 0;
    color: #fff;
    border-radius: 10px 10px 0 0;
}

.gear-info-list {
    display: flex;
    flex-wrap: wrap;
}

.gear-info-list > div {
    width: 300px;
}

.gear-info-left {
    border-right: solid 1px #ccc;

}
.gear-info-item {
    padding: 0 15px;
    display: flex;
    line-height: 30px;
    height: 30px;
    border-top: 1px solid #ccc;

    align-items: center;
}

.gear-info-list :nth-last-of-type(1) {
    border-radius: 0 0 10px 0;
}

.gear-info-list :nth-last-of-type(2) {
    border-radius: 0 0 0 10px;
}

.active-gear {
    background: #dbe8f3;
}

.gear-info-item .gearinfo-item-name {
    width: 60px;
    color: #003c84;
    font-weight: bold;
}

.gear-info-item .separator { 
    height: 20px;
    background: #ccc;
    margin-right: 10px;
}

&.race-gear-legend-m {
    color: #333;
    display: block;
    text-align: left;
    width: 95vw;
    background-color: #F4F4F4;
    padding: 0;
    height: auto;
    border-radius: 10px;
    box-shadow: 0px 3px 8px #333;
}

&.race-gear-legend-m div {
    display: block;
    text-align: left;
    height: auto;
    padding: 0;
}

&.race-gear-legend-m h5 {
    ${text_size(15)}
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    font-weight: bold;
    background-color: #122c68;
    margin: 0;
    color: #fff;
    border-radius: 10px 10px 0 0;
}

&.race-gear-legend-m .gear-info-list {
    display: flex;
    flex-wrap: wrap;
}

&.race-gear-legend-m .gear-info-list>div {
    width: 50%;
}

&.race-gear-legend-m .gear-info-left {
    border-right: solid 1px #ccc;
}

&.race-gear-legend-m .gear-info-item {
    padding: 0 15px 0 10px;
    display: flex;
    min-height: 30px;
    border-top: 1px solid #ccc;
    align-items: center;
}

&.race-gear-legend-m .gear-info-list :nth-last-of-type(1) {
    border-radius: 0 0 10px 0;
}

&.race-gear-legend-m .gear-info-list :nth-last-of-type(2) {
    border-radius: 0 0 0 10px;
}

&.race-gear-legend-m .active-gear {
    background: #DBE8F3;
}

&.race-gear-legend-m .gear-info-item .gearinfo-item-name {
    width: 20%;
    color: #003c84;
    font-weight: bold;
}

&.race-gear-legend-m .gear-info-item .gearinfo-item-value {
    width: calc(80% - 1px);
    ${text_size(13)}
}

&.race-gear-legend-m .gear-info-item .separator {
    width: 1px;
    height: 70%;
    background: #ccc;
    margin-right: 10px;
}

`;
interface propType {
  setRacesDetailLoading?: (loading: boolean) => void;
    gearData?: [];
    gear?: string;
    type?: string
}
const GearInfo: React.FC<propType> = (props: propType) => {
  const [gear, setGear] = useState<any>([])
  const [gearConfig,setGearConfig] = useState<any>([])

  const { state: lang } = useLanguage();
  const { t } = lang;

  useEffect(()=>{
    setGearConfig(props.gearData?.filter((x: any) => x.gearName.value))
    setGear(getGear(props?.gear ?? "")) 
    
  },[props.gearData]) 
  const getGear = (data: string) => {
    if(!data) return []
    let gear = []
    if(data.includes('1')){
      gear.push('"1"')
      data = data.replace(/1/g,'')
    }
    if(data.includes('2')){
      gear.push('"2"')
      data = data.replace(/2/g,'')
    }
    if(data.includes('-')){
      gear.push('"-"')
      data = data.replace(/-/g,'')
    }
    if(data.includes('/')){
      return gear.concat(data.split('/'))
    }else{
      return gear.concat(data.split(' '))
    }   
    
  }

  return<>
   <Container className={props.type == "mobile" ? "race-gear-legend-m" : "race-gear-legend pa"}>
    <h5>{t('gear_info_title')}</h5>
    <div className='gear-info-list'>
    {gearConfig?.map((item: any, index: number) => {
          return <div className={`gear-info-item${gear.includes(item.gearCode.value) ? ' active-gear' : ''}${index%2 === 0 ? ' gear-info-left' : '' }`} key={item.gearCode.value}>
            <div className='gearinfo-item-name'>{item.gearCode.value}</div>
            <div className='separator'></div>
            <div className='gearinfo-item-value'>{item.gearName.value} </div>
          </div>
    })}
    {gearConfig?.length % 2 === 1 && <div className='gear-info-item'></div>}
    </div>
  </Container>
  </>
}

export default GearInfo